import { TableContainer, Table, TableRow, TableHead, TableBody, TableFooter, TablePagination, Divider, TextField, Grid } from '@material-ui/core'
import { BrokerPortalContextStore } from '../../context/BrokerPortalContext'
import TablePaginationActions from '@material-ui/core/TablePagination/TablePaginationActions'
import FlexView from 'react-flexview/lib'
import { EmptyMessageTable } from '../Broker/Common/EmptyTableMessage'
import { SessionContextStore } from '../../context/SessionContext'
import { useHistory } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import { SortableTableCell, SortableAndFilterableTableCell } from '../Core/Table/EnhancedTableHead'
import React, { useState,useContext } from 'react';
import { RefferedUserTableRows } from './RefferedUserTableRows'
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'

var classNames = require('classnames')
const statusOptions=["Pending", "Decline", "Approved", "All"]
const boolOptions= ["true", "false", "All"]

export const RefferedUserTable = ({onRowClick}) => {
    const brokerPortalContext = useContext(BrokerPortalContextStore)
    const sessionContext = useContext(SessionContextStore)
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(100);
    const [userNamePrefix, setUserNamePrefix] = React.useState("");
    const [usersLoaded, setUsersLoaded] = React.useState(false);
    const [sortId, setSortId] = React.useState('date_added');
    const [sortOrder, setSortOrder] = React.useState('desc');
    const [results, setResults] = React.useState(brokerPortalContext.referredUsers);
    const history = useHistory()
    const { path, url } = useRouteMatch();
    const [filters, setFilters] = useState({status: 'Pending'});    
    const [searchValue, setSearchValue] = useState('');
    const [currentStatusFilter, setCurrentStatusFilter] = useState('Pending');


    React.useEffect(() => {
        if (!brokerPortalContext.loadingUsers){
            setUsersLoaded(true);
        }
    }, [brokerPortalContext.loadingUsers])

    React.useEffect(() => {
        applyFilterAndSort()
    }, [brokerPortalContext.referredUsers, userNamePrefix, sortId, sortOrder])

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const applyFilterAndSort = () => {
        let filtered = brokerPortalContext.referredUsers.filter(user => accountTableFilterPredicate(user))
        if(sortId != '') {
            filtered = filtered.sort((a, b) => {
                if(a[sortId] < b[sortId])
                    return -1
                else 
                    return 1
            })
            if(sortOrder == 'desc')
                filtered = filtered.reverse()
        }
        setResults(filtered)
        handleFilterChange("status", currentStatusFilter);

    }

    const bindUser = async (email, action) => {
        const res = await sessionContext.bindUserForBroker(email)
        if(res.ok) {
            if(action == 'refferalRequest')
            console.log('path:', path)
                 history.push('/account/refferal-admin-view');
        }
    }

    const onUserClick = (user) => onRowClick && onRowClick(user)

    const handleSearchChange = (event) => {
        handleFilterChange("status", "All");
        const value = event.target.value.toLowerCase();
        setSearchValue(value);
        const filtered = brokerPortalContext.referredUsers.filter((item) => {
          return (
            item.user_name.toString().includes(value) ||
            item.full_name.toLowerCase().includes(value.toLowerCase())
          );
        });
        setResults(filtered)
        };

    const handleChangePage = (event, newPage) => setPage(newPage)
    const handleSortRequest = (id, order) => setSortId(id) || setSortOrder(order)
    

    const accountTableFilterPredicate = (user) => {
        return user.user_name.toLowerCase().includes(userNamePrefix) 
                || `${user.full_name}`.toLowerCase().includes(userNamePrefix);
    }

  const handleFilterChange = (column, filterValue) => {
    setCurrentStatusFilter(filterValue)
    setFilters((prevState) => { 
        return {
            ...prevState,
            [column]: filterValue !== 'All' ? filterValue : undefined,
        }
    });
  };

    const mapedData= results.map((user, index) => (u=> index, user));
    const filteredData = mapedData.filter((row) => {
    return Object.keys(filters).every((column) => {
      const filterValue = filters[column];
      if (!filterValue) {
        return true;
      }
      return String(row[column]).toLowerCase().includes(filterValue.toLowerCase());
    });
  });

    return (
        <>
        <FlexView vAlignContent={'center'} className="space-between">
            <div className="account-table-title full-width margin-right-basic">
                <div className="text-title  blue bold">Referred Users</div>
                {!isMobile && <TextField fullWidth variant="outlined" label="Search" name="search_accounts" className="margin-left-basic" onChange={handleSearchChange}/>}
            </div>
        </FlexView>
        <FlexView className="margin-right-basic">
            </FlexView>
        {isMobile && <TextField variant="outlined" label="Search" name="search_accounts" className="margin-top-6" onChange={handleSearchChange}/>}
        <Divider />
        {usersLoaded && brokerPortalContext.referredUsers.length == 0 ? 
            <EmptyMessageTable message={"we don't have any referred users."} />
        :
        <TableContainer>    
            <Table>
                <TableHead>
                    <TableRow>
                    <SortableTableCell key={'date_added'} handleSortRequest={handleSortRequest} id={'date_added'} currentOrderById={sortId} className="bolder">Date Added
                        </SortableTableCell>
                        <SortableTableCell key={'full_name'} handleSortRequest={handleSortRequest} id={'full_name'} currentOrderById={sortId} className="bolder">Name
                        </SortableTableCell>
                        <SortableTableCell key={'user_name'} handleSortRequest={handleSortRequest} id={'user_name'} currentOrderById={sortId} className="bolder">Email
                        </SortableTableCell>
                        <SortableAndFilterableTableCell key={'status'} handleSortRequest={handleSortRequest} id={'status'} currentOrderById={sortId} filterOptions= {statusOptions} f handleFilterChange={handleFilterChange} firstFilter='Pending' className="bolder" filters={filters}>Status
                        </SortableAndFilterableTableCell>
                        <SortableTableCell key={'had_incidents_or_losses_details'} handleSortRequest={handleSortRequest} id={'had_incidents_or_losses_details'} currentOrderById={sortId} className="bolder">Had Incidents Or Losses
                        </SortableTableCell>
                        <SortableTableCell key={'had_felony_details'} handleSortRequest={handleSortRequest} id={'had_felony_details'} currentOrderById={sortId} className="bolder">Had Felony
                        </SortableTableCell>
                        <SortableTableCell key={'declarations_agreement_details'} handleSortRequest={handleSortRequest} id={'declarations_agreement_details'} currentOrderById={sortId} className="bolder">Declarations Agreement
                        </SortableTableCell>
                        <SortableTableCell key={'overflights_of_people_details'} handleSortRequest={handleSortRequest} id={'overflights_of_people_details'} currentOrderById={sortId} className="bolder">Overflights Of People
                        </SortableTableCell>
                        <SortableTableCell key={'events_with_large_number_of_people_details'} handleSortRequest={handleSortRequest} id={'events_with_large_number_of_people_details'} currentOrderById={sortId} className="bolder">Events With Large Number Of People
                        </SortableTableCell>
                        <SortableTableCell key={'commercial_operations_by_rpac_pilot_details'} handleSortRequest={handleSortRequest} id={'commercial_operations_by_rpac_pilot_details'} currentOrderById={sortId} className="bolder">Commercial Operations By RPAC Pilot
                        </SortableTableCell>
                        <SortableTableCell key={'selected_liability_limit'} handleSortRequest={handleSortRequest} id={'selected_liability_limit'} currentOrderById={sortId} className="bolder">Selected Liability Limit
                        </SortableTableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((user, index) => (
                            <RefferedUserTableRows key={index} user={user}
                             onUserClick={onUserClick} options={[
                                { onClick: () => bindUser(user.user_name, 'refferalRequest'), text:'Refferal Request'},
                            ]}
                            />
                        ))}               
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            colSpan={3}
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            count={filteredData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                                inputProps: { 'aria-label': 'rows per page' },
                                native: true,
                            }}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                        />
                    </TableRow>
                    </TableFooter>
            </Table>
        </TableContainer>}
    </>
    )


}